import { Toast, ToastService } from '../../../services/toast.ts';
import './toast-item.ts';

export class ToastContainer extends HTMLElement {
    private toastService: ToastService;
    private unsubscribe: (() => void) | null = null;

    constructor() {
        super();
        this.toastService = ToastService.getInstance();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
        this.unsubscribe = this.toastService.subscribe((toast: Toast) => {
            this.addToast(toast);
        });
    }

    disconnectedCallback() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    render() {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: fixed;
          top: 1.5rem;
          right: 1.5rem;
          z-index: 20000; /* Higher than modals (10000) */
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          pointer-events: none;
        }
        
        #toast-wrapper {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          pointer-events: none;
        }

        toast-item {
          pointer-events: auto;
        }
      </style>
      <div id="toast-wrapper"></div>
      <slot></slot>
    `;
    }

    private addToast(toast: Toast) {
        const wrapper = this.shadowRoot?.getElementById('toast-wrapper');
        if (!wrapper) return;

        const toastItem = document.createElement('toast-item');
        toastItem.setAttribute('message', toast.message);
        toastItem.setAttribute('type', toast.type);
        toastItem.setAttribute('duration', (toast.duration || 5000).toString());

        toastItem.addEventListener('remove', () => {
            toastItem.remove();
        });

        wrapper.appendChild(toastItem);
    }
}

customElements.define('toast-container', ToastContainer);
